import { render, staticRenderFns } from "./FollowingList.vue?vue&type=template&id=54197a74&scoped=true"
import script from "./FollowingList.vue?vue&type=script&lang=js"
export * from "./FollowingList.vue?vue&type=script&lang=js"
import style0 from "./FollowingList.vue?vue&type=style&index=0&id=54197a74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_7d198ec714527f3eb87755d9f59e0144/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54197a74",
  null
  
)

export default component.exports